<template>
  <div class="gallery-box">
    <div class="ai-gallery-container">
      <div v-if="loading" class="ai-loading-mask">
        <div class="loading-wrapper">
          <div class="icon-circle">
            <i class="el-icon-loading" />
          </div>
          <p class="loading-text">
            正在生成 AI 圖片...
          </p>
          <p class="loading-sub">
            請耐心等待
          </p>
        </div>
      </div>
      <div v-else-if="displayList.length">
        <div class="gal_h">AI圖庫</div>
        <div class="gallery-header">
          <h3>生成結果預覽</h3>
          <p>已保留優化的相片，需自行確認使用AI圖片</p>
        </div>

        <div class="gallery-content scroll-container">
          <div 
            v-for="(item, index) in displayList" 
            :key="index" 
            class="gallery-card comparison-item"
          >
            <div class="image-comparison">
              <div class="img-box">
                <span class="tag original">原圖</span>
                <el-image 
                  :src="item.originalImageUrl + '?x-oss-process=style/300xauto_f'" 
                  fit="cover"
                />
                <!-- <div class="img-name">{{ getFileName(item.originalImageUrl) }}</div> -->
              </div>
              
              <div class="divider-arrow">
                <i class="el-icon-caret-right" />
              </div>

              <div 
                class="img-box" 
                @click="handlePreview(index, 'ai')"
              >
                <span class="tag ai-gen">AI圖</span>
      
                <!-- <template v-if="getCurrentAIUrl(item)"> -->
                <template v-if="item.aiImages[item.selectedVersion].status === 1">
                  <el-image 
                    :key="item.originalImageUrl + item.selectedVersion + (item.refreshKey || '')"
                    fit="cover"
                    :src="getCurrentAIUrl(item) + '?x-oss-process=style/300xauto_f&t=' + (item.refreshKey || '')"
                    @error="handleImageError(item)"
                  >
                    <!-- <div
                      slot="placeholder"
                      class="image-slot"
                    >
                      <i class="el-icon-loading" /> 加載中...
                    </div> -->
                    <!-- 加载失败时的自定义内容 -->
                    <div
                      slot="error"
                      class="image-error-slot">
                      <div class="error-retry-content">
                        <i class="el-icon-picture-outline" />
                        <p>加載失敗</p>
                        <el-button 
                          type="text" 
                          icon="el-icon-refresh" 
                          @click="retryLoad(item)"
                        >
                          点击重試
                        </el-button>
                      </div>
                    </div>
                  </el-image>
                </template>
                <div
                  v-else-if="item.aiImages[item.selectedVersion].status === 3"
                  class="ai-error-layer"
                >
                  <div 
                    class="bg-mask" 
                    :style="getBlurBgStyle(item.originalImageUrl)"
                  />
                  <div class="error-content">
                    <p class="error-title">
                      AI圖片生成失敗
                    </p>
                    <span class="error-icon">
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use xlink:href="#icontupianshengchengshibai" />
                      </svg>
                    </span>
                    <p class="sub-text">
                      請聯繫客服：3619 3218
                    </p>
                  </div>
                </div>


                <div
                  v-else
                  class="ai-loading-layer"
                >
                  <div 
                    class="bg-mask" 
                    :style="getBlurBgStyle(item.originalImageUrl)"
                  />
                  <div class="loading-content">
                    <p class="loading-text">
                      AI圖片生成中...
                    </p>
                    <i class="el-icon-loading" />
                    <p class="sub-text">
                      正在進行深度圖像修補，這可能需要一
                      <br>
                      點時間，請稍候...
                    </p>
                  </div>
                </div>
                <!-- <div class="img-name">{{ getFileName(item.originalImageUrl) }}</div> -->
              </div>
            </div>

            <div class="card-footer">
              <div
                v-show="item.aiImages.length > 1"
                class="footer-left"
              >
                <span class="label">生成版本</span>
                <el-select 
                  v-model="item.selectedVersion" 
                  size="mini" 
                  @change="handleVersionChange(item)" 
                >
                  <el-option 
                    v-for="(ai, aiIdx) in item.aiImages" 
                    :key="aiIdx" 
                    :label="ai.versionNumber" 
                    :value="aiIdx" 
                  />
                </el-select>
                <div 
                  v-if="shouldShowNewTag(item)" 
                  class="tagbox"
                >
                  <i class="el-icon-info" />
                  <span 
                    class="new-version-tag"
                  >
                    有新版本生成
                  </span>
                </div>
              </div>
              
              <div class="footer-right">
                <div class="action-radio">
                  <span class="red">請檢查AI生成結果並確認保留</span>
                  <el-radio
                    v-model="item.useType"
                    label="original"
                  >
                    使用原圖
                  </el-radio>
                  <el-radio
                    v-model="item.useType"
                    label="ai"
                    :disabled="!getCurrentAIUrl(item)"
                  >
                    套用AI圖
                  </el-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="noimg-container"
      >
        <div class="noimg-header">
          AI圖庫 
        </div>
        <img
          src="../../../assets/ai_default.png"
          alt
          width="140"
          height="140"
        >
        <div class="noimg-footer">
          <div class="noimg-text">
            尚未生成任何相片
          </div>
          <div class="noimg-sub">
            ~可通過AI執相處理相片~
          </div>
        </div>
      </div>
    </div>
    <div class="gallery-footer" v-if="displayList.length && !loading">
      <el-button
        size="small"
        :disabled="isAnyAiProcessing"
        @click="batchSetUseType('original')"
      >
        一鍵確認原圖
      </el-button>
      <el-button 
        size="small" 
        :disabled="isAnyAiProcessing" 
        @click="batchSetUseType('ai')"
      >
        一鍵確認AI圖
      </el-button>
      <el-button 
        type="primary" 
        :disabled="isAnyAiProcessing" 
        :class="{'disabled-btn': isAnyAiProcessing}"
        size="medium" 
        @click="handleFinalSubmit"
      >
        提交確認
      </el-button>
    </div>
    <div v-if="enLarge" class="enLarge" style="z-index: 3000;">
      <span class="el-image-viewer__btn el-image-viewer__close" @click="enLarge = false">
        <i class="el-icon-circle-close" />
      </span>
      
      <!-- <span class="el-image-viewer__btn el-image-viewer__prev" @click="changePreviewImg('prev')">
        <i class="el-icon-arrow-left" />
      </span>
      <span class="el-image-viewer__btn el-image-viewer__next" @click="changePreviewImg('next')">
        <i class="el-icon-arrow-right" />
      </span> -->

      <div class="el-image-viewer__canvas">
        <img
          :key="previewIndex"
          :src="getBigImageUrl(displayList[previewIndex])"
          class="el-image-viewer__img"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiGallery',
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    submitResult: {
      type: Object,
      default: null
    },
    orderList: {
      type: Array,
      default: () => []
    },
    oldData:{
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enLarge: false,     // 控制大图显示
      previewIndex: 0,
      // -------旧版本快照------
      // 增加一个本地的“已读”状态记录，防止轮询覆盖掉用户已经消除的提示
      localViewedIds: new Set(),
      // -----旧版本快照--------

      // 真正用于渲染和绑定的数组
      displayList: [],
      // 用于标记是否是刚打开弹窗，由父组件控制或通过 watch 逻辑判断
      isSessionActive: false
      // dataList:[],
      // tt:[],
    }
  },
  computed: {
    isAnyAiProcessing() {
      // 遍历 displayList 中的每一组图片
      return this.displayList.some(group => {
        // 只要这组图片里有一个版本的 aiImageUrl 为空（null 或 ""），就代表还在处理中
        return group.aiImages.some(ai => ai.status === 2);
      });
    },
    // formattedList() {
    //   const map = {};
    //   // 注意：这里使用 this.dataList 是从父组件传入的 props
    //   this.dataList.forEach(item => {
    //     const key = item.originalImageUrl;
    //     if (!map[key]) {
    //       // 使用 $set 确保属性是响应式的，或者直接初始化完整对象
    //       map[key] = {
    //         originalImageUrl: key,
    //         // 初始选中逻辑：如果后端返回 isUsedAIImage 为 true，则勾选 ai
    //         useType: item.isUsedAIImage ? 'ai' : 'original',
    //         selectedVersion: 0, 
    //         aiImages: []
    //       };
    //     }
        
    //     // 只要有版本信息就存入，哪怕 aiImageUrl 暂时为 null（表示生成中）
    //     map[key].aiImages.push({
    //       aiImageUrl: item.aiImageUrl,
    //       versionNumber: item.versionNumber,
    //       status: item.status, // 2 通常代表生成中
    //       id: item.id
    //     });
    //   });

    //   // 排序：确保 V1, V2 顺序正确
    //   const result = Object.values(map);
    //   result.forEach(group => {
    //     group.aiImages.sort((a, b) => a.versionNumber.localeCompare(b.versionNumber));
    //   });
    //   return result;
    // }
  },
  watch: {
    // --------------旧版本快照-------------
    dataList: {
      handler(val) {
        if (!val || val.length === 0) {return;}
        this.transformData(val);
      },
      immediate: true,
      deep: true
    },
    // 新增：当旧数据基准变化时（比如点提交后重开），清空本地已读状态
    oldData: {
      handler() {
        this.localViewedIds.clear();
      },
      deep: true
    },
    // ----------旧版本快照-------------------

    submitResult: {
      handler(val) {
        if (val) {
          this.showResultDialog(val);
        }
      },
      immediate: true // 如果是用 v-if 切换的，immediate 确保组件加载时就能触发
    },
    // dataList: {
    //   handler(val, oldVal) {
    //     if (!val || val.length === 0) {return};
    //     console.log(val,':::val---oldval:::', oldVal);
    //     // 逻辑判断：如果 oldVal 为空，说明是关闭后重新打开，不显示黄色小字
    //     if (!oldVal || oldVal.length === 0) {
    //       this.isSessionActive = false;
    //     } else {
    //       // 如果是轮询过程中数据变化，激活“新版本提示”逻辑
    //       this.isSessionActive = true;
    //     }
    //     this.transformData(val);
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  created() {
  },
  methods: {
  // 点击图片时触发
  handlePreview(index, type) {
      // 如果点击的是 AI 图但 AI 还没生成好，可以不弹窗或只看原图
      const item = this.displayList[index];
      if (type === 'ai' && item.aiImages[item.selectedVersion].status !== 1) {
        return; 
      }
      
      this.previewIndex = index;
      this.enLarge = true;
    },

    // 获取高清大图地址
    getBigImageUrl(item) {
      if (!item) {return '';}
      
      // 这里可以根据业务逻辑决定：大图是永远看 AI 图，还是根据当前状态选
      const aiUrl = this.getCurrentAIUrl(item);
      const isAiReady = item.aiImages[item.selectedVersion].status === 1;
      
      // 逻辑：如果 AI 图好了就优先看 AI，否则看原图
      const url = (isAiReady && aiUrl) ? aiUrl : item.originalImageUrl;
      
      // 使用 OSS 的 master 样式获取高清图
      return url.split('?')[0] + '?x-oss-process=style/master';
    },

    // 左右切换
    // changePreviewImg(direction) {
    //   const total = this.displayList.length;
    //   if (direction === 'next') {
    //     this.previewIndex = (this.previewIndex + 1) % total;
    //   } else {
    //     this.previewIndex = (this.previewIndex - 1 + total) % total;
    //   }
    // },
    // 当 el-image 报错时触发
    handleImageError(item) {
      // 你可以在这里做一些记录，或者只是静默等待用户点击重试
      console.error("图片加载失败:", item.originalImageUrl);
    },

    // 刷新按钮调用的方法
    retryLoad(item) {
      // 核心逻辑：更新 refreshKey 触发 Vue 重新渲染该 el-image
      // 并在 URL 后面拼接新的时间戳，防止浏览器缓存
      if (this.$set) {
        // 确保是响应式的
        this.$set(item, 'refreshKey', Date.now());
      } else {
        item.refreshKey = Date.now();
      }
      
      this.$message({
        message: '正在嘗試重新加載圖片...',
        type: 'info',
        duration: 1000
      });
    },
    showResultDialog(result) {
        const { successCount, failureCount } = result;
        let messageContent = '';
        messageContent = `成功提交${successCount}張圖片，實際扣除${successCount}次額度`;
        if (failureCount > 0) {
          messageContent += (successCount > 0 ? '<br>' : '') + `提交失敗${failureCount}張圖片，實際未扣除${failureCount}次額度`;
        }
        this.$emit('confirm-result-shown'); 
        this.$confirm(
          messageContent, 
          '提示', 
          { confirmButtonText: '確認', type: 'success' ,customClass: 'ai-confirm' , iconClass: 'el-icon-info',showCancelButton: false,closeOnClickModal: false,dangerouslyUseHTMLString: true }
        ).then(() => {
          // 弹窗关闭后，通知父组件将 lastSubmitResult 置为 null
          // this.$emit('confirm-result-shown'); 
        });
    },
    // handleVersionChangess(item) {
    //   const newestIdx = item.aiImages.length - 1;
    //   if (item.selectedVersion === newestIdx) {
    //     item.hasViewedNewest = true; // 永久消除该组的黄色小字，直到下次新图生成
    //   }
    //   this.$forceUpdate();
    // },

    // // 需求 3: 黄色小字显隐规则
    // shouldShowNewTagss(item) {
    //   // 规则：只有在“新任务活跃会话”中，且未选中最新版本，且未手动消除过时展示
    //   if (!this.isSessionActive) {return false};
      
    //   const newestIdx = item.aiImages.length - 1;
    //   // 如果当前选中的不是最后一位，且用户还没点过最新版，就显示
    //   return item.selectedVersion < newestIdx && !item.hasViewedNewest;
    //   // return !item.hasViewedNewest;
    // },
    // ------------旧版本快照--------------
    handleVersionChange(item) {
      const newestIdx = item.aiImages.length - 1;
      const newestItem = item.aiImages[newestIdx];

      // 如果切到了最新版本，记录 ID 到已读集合
      if (item.selectedVersion === newestIdx && newestItem) {
        this.localViewedIds.add(newestItem.id);
      }
      
      this.$forceUpdate();
    },
    shouldShowNewTag(item) {
      // 1. 如果这组图根本没有新生成的（对应 oldData），直接不显示
      if (!item.isGroupActive) {return false;}

      const newestIdx = item.aiImages.length - 1;
      const newestItem = item.aiImages[newestIdx];
      // 2. 如果当前选中的已经是最新版，自动视为“已读”
      if (item.selectedVersion === newestIdx) {
        if (newestItem) {this.localViewedIds.add(newestItem.id);}
        return false;
      }

      // 3. 如果 ID 在已读集合里，不显示；否则显示
      return newestItem ? !this.localViewedIds.has(newestItem.id) : false;
    },
    transformData(rawList) {
      const map = {};
      
      // --- A. 建立旧数据基准索引 (用 ID 集合判断最准确) ---
      const oldIds = new Set(this.oldData.map(item => item.id));

      // 1. 分组逻辑 (保持不变)
      rawList.forEach(item => {
        const key = item.originalImageUrl ? item.originalImageUrl.split('?')[0] : '';
        if (!key){ return;}

        if (!map[key]) {
          this.$set(map, key, {
            originalImageUrl: key,
            useType: 'original',
            selectedVersion: 0,
            aiImages: [],
            // 新增/修改属性
            isGroupActive: false, // 标识该组是否有新生成的图
          });
        }
        map[key].aiImages.push({
          aiImageUrl: item.aiImageUrl,
          versionNumber: item.versionNumber,
          status: item.status,
          id: item.id,
          isUsedAIImage: item.isUsedAIImage
        });
      });
      // 2. 预处理
      Object.values(map).forEach(group => {
        // group.aiImages.sort((a, b) => a.versionNumber.localeCompare(b.versionNumber, undefined, { numeric: true }));
        group.aiImages.sort((a, b) => {
          // 1. 首先按版本号比对
          const versionCompare = a.versionNumber.localeCompare(b.versionNumber, undefined, { numeric: true });
          
          if (versionCompare !== 0) {
            return versionCompare;
          }
          
          // 2. 如果版本号一模一样，按 createTime 排序（时间晚的在后面）
          // 也可以直接用 ID：return a.id - b.id;
          return new Date(a.createTime) - new Date(b.createTime);
        });

        const newestIdx = group.aiImages.length - 1;
        const newestItem = group.aiImages[newestIdx];
        const usedIdx = group.aiImages.findIndex(ai => ai.isUsedAIImage === true);
        // --- 选中逻辑 ---
        if (usedIdx !== -1) {
          group.useType = 'ai';
          group.selectedVersion = usedIdx;
        } else {
          group.useType = 'original';
          group.selectedVersion = newestIdx;
        }
        // --- B. 基于 oldData 判断是否显示“新版本生成” ---
        // 逻辑：如果当前组最新的 ID 不在任务开始前的 oldIds 里，说明是刚生成的
        if (newestItem && !oldIds.has(newestItem.id) && oldIds.size > 0) {
          group.isGroupActive = true; 
        } else {
          group.isGroupActive = false;
        }
      });

      // 3. 排序逻辑 (保持不变)
      const finalOrderedList = [];
      this.orderList.forEach(path => {
        const purePath = path.split('?')[0];
        if (map[purePath]) {finalOrderedList.push(map[purePath]);}
      });

      // 4. 如果后端返回了 orderList 里没有的图（兜底逻辑），也补在后面
      Object.keys(map).forEach(key => {
        if (!this.orderList.some(p => p.split('?')[0] === key)) {
          finalOrderedList.push(map[key]);
        }
      });
      this.displayList = finalOrderedList;
    },
    // ---------旧版本快照---------------------


    // transformDatass(rawList) {
    //   const map = {};
      
    //   // 1. 先进行分组（和之前逻辑一样）
    //   rawList.forEach(item => {
    //     // 统一去掉 OSS 参数做 key
    //     const key = item.originalImageUrl ? item.originalImageUrl.split('?')[0] : '';
    //     if (!key) {return};

    //     if (!map[key]) {
    //       this.$set(map, key, {
    //         originalImageUrl: key,
    //         useType: 'original',
    //         selectedVersion: 0,
    //         aiImages: [],
    //         hasViewedNewest: false
    //       });
    //     }
    //     map[key].aiImages.push({
    //       aiImageUrl: item.aiImageUrl,
    //       versionNumber: item.versionNumber,
    //       status: item.status,
    //       id: item.id,
    //       isUsedAIImage: item.isUsedAIImage
    //     });
    //   });

    //   // 2. 预处理：给每一组的 aiImages 排序，并确定默认选中项
    //   Object.values(map).forEach(group => {
    //     // 排序 V1, V2, V3
    //     group.aiImages.sort((a, b) => a.versionNumber.localeCompare(b.versionNumber, undefined, { numeric: true }));
    //     const newestIdx = group.aiImages.length - 1; // 获取最新版本的索引
    //     const usedIdx = group.aiImages.findIndex(ai => ai.isUsedAIImage === true);
    //     if (usedIdx !== -1) {
    //       group.useType = 'ai';
    //       group.selectedVersion = usedIdx;
    //       if (usedIdx === newestIdx) {
    //         group.hasViewedNewest = true;
    //       }
    //     } else {
    //       group.useType = 'original';
    //       group.selectedVersion = group.aiImages.length - 1;
    //       group.hasViewedNewest = true;
    //     }
    //   });

    //   // 3. 【核心修改】：按照父组件传来的 orderList 进行重排
    //   const finalOrderedList = [];
      
    //   this.orderList.forEach(path => {
    //     // 确保路径干净（去掉参数）
    //     const purePath = path.split('?')[0];
    //     if (map[purePath]) {
    //       finalOrderedList.push(map[purePath]);
    //     }
    //   });

    //   // 4. 如果后端返回了 orderList 里没有的图（兜底逻辑），也补在后面
    //   Object.keys(map).forEach(key => {
    //     if (!this.orderList.some(p => p.split('?')[0] === key)) {
    //       finalOrderedList.push(map[key]);
    //     }
    //   });

    //   this.displayList = finalOrderedList;
    // },

    // transformData(rawList) {
    //   const map = {};
    //   rawList.forEach(item => {
    //     const key = item.originalImageUrl;
    //     if (!map[key]) {
    //       this.$set(map, key, {
    //         originalImageUrl: key,
    //         useType: 'original',
    //         selectedVersion: 0,
    //         aiImages: [],
    //         hasViewedNewest: false // 需求 3: 记录用户是否点击过最新版
    //       });
    //     }
    //     map[key].aiImages.push({
    //       aiImageUrl: item.aiImageUrl,
    //       versionNumber: item.versionNumber,
    //       status: item.status,
    //       id: item.id,
    //       isUsedAIImage: item.isUsedAIImage
    //     });
    //   });

    //   const result = Object.values(map);
    //   result.forEach(group => {
    //     // 1. 排序（确保 V1, V2, V3 顺序）
    //     group.aiImages.sort((a, b) => a.versionNumber.localeCompare(b.versionNumber, undefined, {numeric: true}));
        
    //     // 2. 寻找是否有已勾选的版本
    //     const usedIdx = group.aiImages.findIndex(ai => ai.isUsedAIImage === true);
        
    //     if (usedIdx !== -1) {
    //       // 需求 1: a图片 V2 勾选为 AI，保持选中 V2，不自动切 V3
    //       group.useType = 'ai';
    //       group.selectedVersion = usedIdx;
    //     } else {
    //       // 需求 2: b图片勾选原图，默认选中最后一个版本（V3）
    //       group.useType = 'original';
    //       group.selectedVersion = group.aiImages.length - 1;
    //     }
    //   });

    //   this.displayList = result;
    // },

    getSelectedAI(item) {
      const current = item.aiImages[item.selectedVersion];
      return current ? current.url : null;
    },
    // 修改：确保背景图 URL 100% 能够加载（复用左侧已成功的 style）
    getBlurBgStyle(url) {
      if (!url) {return {}};
      const pureUrl = url.split('?')[0];
      const thumbUrl = `${pureUrl}?x-oss-process=style/300xauto_f`;
      
      return {
        backgroundImage: `url(${thumbUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute', // 确保在 mask 内部撑满
        inset: 0
      };
    },
    // 确保这个方法能被模板正确调用
    getCurrentAIUrl(item) {
      if (!item.aiImages || item.aiImages.length === 0) {return null};
      // 获取当前选中的版本对象
      const current = item.aiImages[item.selectedVersion];
      // 返回对应的 aiImageUrl
      return (current && current.status === 1) ? current.aiImageUrl : null;
    },
    getFileName(url) {
      if (!url) {return 'image.jpg'};
      const path = url.split('?')[0];
      return path.substring(path.lastIndexOf('/') + 1) || 'image.jpg';
    },
    batchSetUseType(type) {
      this.displayList.forEach(item => {
        if (type === 'ai') {
          const current = item.aiImages[item.selectedVersion];
          // 只有当该图片已经生成了 AI 结果时，才允许勾选“套用AI图”
          if (current && current.status === 1) {
            item.useType = 'ai';
          } else {
            // 如果 AI 还没生成好，强制维持在“使用原图”状态，并可以给个提示
            item.useType = 'original';
          }
        } else {
          // 一键确认原图
          item.useType = 'original';
        }
      });
      
      // 如果发现界面没刷新，可以手动触发一次强制更新（虽然上面设置了响应式，但保险起见）
      this.$forceUpdate();
    },

    handleFinalSubmit() {
      // apiPayload 存放需要发给后端的数组：[{id: 1, isUsedAIImage: true}, {id: 2, isUsedAIImage: false}, ...]
      const apiPayload = [];
      // syncToParent 存放传给父组件更新 UI 的精简数据
      const syncToParent = [];

      this.displayList.forEach(group => {
        // 1. 确定当前用户选中的版本索引（下拉框选中的那个）
        const selectedIdx = group.selectedVersion;
        // 2. 用户是否在该组勾选了“套用AI图”
        const isAiUsedAtAll = group.useType === 'ai';

        // 关键逻辑：遍历该组下“所有”版本，处理互斥状态
        group.aiImages.forEach((aiItem, index) => {
          // 只有当 group.useType 是 'ai' 且当前版本正是下拉框选中的那个版本时，才为 true
          const isThisVersionSelected = isAiUsedAtAll && index === selectedIdx;

          apiPayload.push({
            id: aiItem.id, 
            isUsedAIImage: isThisVersionSelected
          });
        });

        // 3. 构造传给父组件的数据（父组件通常只需要知道最终这张图展示哪张，不需要管互斥细节）
        const hasAiVersions = group.aiImages && group.aiImages.length > 0;
        syncToParent.push({
          originalImageUrl: group.originalImageUrl,
          isUsedAIImage: isAiUsedAtAll,
          isHaveAIImage: true,
          // 如果勾选了 AI，传回当前选中的那个版本的 URL
          // selectedAiUrl: isAiUsedAtAll ? group.aiImages[selectedIdx].aiImageUrl : null
          selectedAiUrl: hasAiVersions ? group.aiImages[selectedIdx].aiImageUrl : null
        });
      });

      // 安全检查：防止提交生成中的图片
      const hasIncomplete = this.displayList.some(item => item.useType === 'ai' && !this.getCurrentAIUrl(item));
      if (hasIncomplete) {
        this.$message.warning('部分圖片AI尚未生成完畢，無法套用');
        return;
      }

      // 触发确认事件，此时 apiPayload 会包含所有版本的 true/false 状态
      this.$emit('confirm', { apiPayload, syncToParent });
    },

    // transformData(rawList) {
    //   const map = {};
    //   rawList.forEach(item => {
    //     const key = item.originalImageUrl;
    //     if (!map[key]) {
    //       // 使用 $set 或直接初始化，确保属性是响应式的
    //       this.$set(map, key, {
    //         originalImageUrl: key,
    //         useType: 'original', // 默认原图
    //         selectedVersion: 0,
    //         aiImages: []
    //       });
    //     }
    //     map[key].aiImages.push({
    //       aiImageUrl: item.aiImageUrl,
    //       versionNumber: item.versionNumber,
    //       status: item.status,
    //       id: item.id,
    //       isUsedAIImage: item.isUsedAIImage // 保存原始状态
    //     });
    //   });

    //   const result = Object.values(map);
    //   result.forEach(group => {
    //     // 排序
    //     group.aiImages.sort((a, b) => a.versionNumber.localeCompare(b.versionNumber));
        
    //     // 关键：初始化选中状态
    //     // 遍历所有版本，如果有任何一个版本 isUsedAIImage 为 true，则该组设为 'ai'
    //     const activeIndex = group.aiImages.findIndex(ai => ai.isUsedAIImage === true);
    //     if (activeIndex !== -1) {
    //       group.useType = 'ai';
    //       group.selectedVersion = activeIndex;
    //     }
    //   });
    //   this.displayList = result;
    // },
    // 提交逻辑修正：处理 finalImageUrl 的取值
    // handleFinalSubmit() {
    //   // 1. 构造提交给后端接口 Payload: [{id: 97, isUsedAIImage: true}, ...]
    //   // 2. 构造传给父组件更新 UI 的数据
    //   const apiPayload = [];
    //   const syncToParent = [];

    //   // 注意：这里要循环你保存在 data 里的那个响应式数组（假设你改名叫 displayList 了）
    //   this.displayList.forEach(group => {
    //     const selectedVersionObj = group.aiImages[group.selectedVersion];
        
    //     // 无论是否选中 AI，都记录下这一组的状态
    //     const isAiUsed = group.useType === 'ai';
        
    //     apiPayload.push({
    //       id: selectedVersionObj.id, 
    //       isUsedAIImage: isAiUsed
    //     });

    //     syncToParent.push({
    //       originalImageUrl: group.originalImageUrl,
    //       isUsedAIImage: isAiUsed,
    //       selectedAiUrl: selectedVersionObj.aiImageUrl
    //     });
    //   });
    //   const hasIncomplete = this.displayList.some(item => item.useType === 'ai' && !this.getCurrentAIUrl(item));
    //   if (hasIncomplete) {
    //     this.$message.warning('部分圖片AI尚未生成完畢，無法套用');
    //     return;
    //   }
    //   // 触发确认事件，把这两个数据都传出去
    //   this.$emit('confirm', { apiPayload, syncToParent });
    // }
  }
}
</script>

<style lang="less" scoped>
.ai-gallery-container {
  height: 100%;
  // height: 495px;
  display: flex;
  flex-direction: column;
  // --------------------------------------------
  padding: 30px 60px;
  padding-bottom: 0;
  .el-select {
    width: 100px;
  }
  .ai-loading-mask {
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    height: 556px;
    background: rgba(255, 255, 255, 0.95);
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-wrapper {
      text-align: center;

      .icon-circle {
        display: flex; // 关键：使用 flex 居中
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        margin: 0 auto 20px;
        
        .el-icon-loading {
          font-size: 40px;
          color: #409EFF;
          // 强制重置旋转中心
          display: block; 
          line-height: 1; 
          margin: 0;
        }
      }

      .loading-text {
        font-size: 16px;
        color: #303133;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .loading-sub {
        font-size: 13px;
        color: #909399;
      }
    }
  }
  .ai-error-layer {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .error-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: #333; /* 根据你的截图，失败文字是黑色的 */
  }

  .error-title {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .error-icon {
    height: 80px;
    display: inline-block;
    font-size: 50px;
  }

  .sub-text {
    font-size: 12px;
    color: #333333;
    line-height: 1.5;
  }

  /* 遮罩层共用逻辑 */
  .bg-mask {
    filter: blur(8px);
    opacity: 0.4;
    background-color: #fff;
  }
  .noimg-container{
    height: 441px;
    margin-top: 147px;
    text-align: center;
  }
  .noimg-header{
    font-size: 21px;
    color: #44444F;
    width: 100%;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .noimg-footer{
    margin-top: 20px;

    .noimg-text{
      font-size: 18px;
      color: #44444F;
      width: 100%;
      text-align: center;
      font-weight: bold;
    }
    .noimg-sub{
      font-size: 14px;
      color: #909399;
      margin-top: 5px;
      text-align: center;
      letter-spacing: 2px;
    }
  }
  .gal_h{
    font-size: 21px;
    color:#44444F;
    text-align: center;
    font-weight: bold;
    padding: 11px 0;
  }
  .gallery-header {
    margin-bottom: 15px;
    h3 { margin: 0 0 5px 0; color: #303133; }
    p { margin: 0; font-size: 13px; color: #909399; }
  }

  /* 核心：滚动捕捉容器 */
  .scroll-container {
    flex: 1;
    overflow-y: auto;
    scroll-snap-type: y mandatory; /* 开启纵向强制捕捉 */
    scrollbar-width: thin;
    padding-right: 10px;
    height: 393px;

    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-thumb { background: #dcdfe6; border-radius: 3px; }

    .comparison-item {
      scroll-snap-align: start; /* 滚动停止时对齐顶部 */
      scroll-snap-stop: always; /* 保证一次只滑过一个 */
      margin-bottom: 10px; /* 增加间距防止视觉拥挤 */
      border: 1px solid #DBDBDB;
      border-radius: 8px;
      overflow: hidden;
      background: #fff;
    }
  }

  .image-comparison {
    display: flex;
    padding: 20px;
    background: #ffffff;
    align-items: center;
    gap: 15px;

    .img-box {
      flex: 1;
      position: relative;
      aspect-ratio: 4 / 3; // 【新增】设置宽高比，图片会随宽度等比拉伸
      min-height: 240px;  // 【可选】设置一个最小高度防止图片过小
      // height: 240px;
      background: #eee;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      .tag {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 3;
        padding: 2px 8px;
        font-size: 12px;
        border-radius: 4px;
        color: #fff;
        &.original { background: rgba(230, 162, 60, 0.9); }
        &.ai-gen { background: rgba(230, 162, 60, 0.9); }
      }
      .image-error-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #f5f7fa; /* 灰底 */
        color: #909399;
        font-size: 14px;
        margin-top: 100px;
      }

      .error-retry-content {
        text-align: center;
      }

      .error-retry-content i {
        font-size: 24px;
        margin-bottom: 8px;
        margin-top: 99px;
      }

      .error-retry-content p {
        margin: 4px 0;
      }

      /* 调整重试按钮的颜色和间距 */
      .error-retry-content .el-button--text {
        color: #409EFF;
        padding: 0;
        margin-top: 5px;
      }
            // .img-name {
      //   position: absolute;
      //   bottom: 10px; /* 改为底部展示，不遮挡文字 */
      //   left: 10px;
      //   z-index: 3;
      //   color: #fff;
      //   font-size: 11px;
      //   background: rgba(0,0,0,0.5);
      //   padding: 2px 6px;
      //   border-radius: 2px;
      //   max-width: 80%;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      //   white-space: nowrap;
      // }

      .el-image { width: 100%; height: 100%; }

      /* AI 加载层样式 */
      .ai-loading-layer {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .bg-mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-size: cover;
          background-position: center;
          /* 核心：高斯模糊效果 */
          filter: blur(12px); 
          transform: scale(1.1); /* 略微放大防止边缘留白 */
          z-index: 1;
        }

        /* 蒙层，增加对比度让文字可读 */
        &::after {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(255, 255, 255, 0.3);
          z-index: 2;
        }

        .loading-content {
          position: relative;
          z-index: 10;
          text-align: center;
          padding: 0 15px;

          .el-icon-loading {
            font-size: 70px;
            color: #333333;
            margin-bottom: 10px;
          }
          .loading-text { font-size: 18px; color: #333333; font-weight: bold; margin-bottom: 5px; }
          .sub-text { font-size: 12px; color: #333333; line-height: 1.4; }
        }
      }
    }

    .divider-arrow { font-size: 24px; color: #dcdfe6; }
  }

  .card-footer {
    padding: 12px 20px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f0f2f5;

    .footer-left {
      display: flex;
      align-items: center;
      gap: 8px;
      .label { font-size: 14px; color: #171725; }
    }
    // 新增/修改：确保右侧始终靠右
    .footer-right {
      margin-left: auto; 
      display: flex;
      align-items: center;
      .red{
        color: red;
        margin-right: 10px;
      }
      /deep/.el-radio__label{
        padding-left: 0px;
      }
    }
    .tagbox{
      background-color: #FFF6E0;
      width: 100px;
      height: 26px;
      text-align: center;
      border-radius: 6px;
      margin-left: 8px; // 建议给标签加点左边距，防止和下拉框贴太近
      .el-icon-info{
        color: #FFA923;
      }
    }
    .new-version-tag{
      font-size: 12px;
      color:#C75F00 ;
      line-height: 26px;
    }
  }

  .gallery-footer {
    padding: 15px 0;
    margin-top: 10px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
  }
}
.gallery-footer {
    padding: 20px 20px;
    background-color: #f9f9f9;
    margin-top: 10px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    border-radius: 10px;
    .disabled-btn{
      background-color: #909399;
    }
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
  }
.enLarge {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    max-height: 80%;
  }
}

.el-image-viewer__btn {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: .8;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
}

.el-image-viewer__close {
  top: 40px;
  right: 40px;
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #fff;
}

.el-image-viewer__prev, .el-image-viewer__next {
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  font-size: 24px;
  color: #fff;
  background-color: #606266;
}

.el-image-viewer__prev { left: 40px; }
.el-image-viewer__next { right: 40px; }

.el-image-viewer__img {
  transition: transform .3s;
}
</style>